module.exports = __webpack_public_path__ + "static/media/joris.72baa51d.jpg";